import React from "react";
import PieChart from "../piechart";

const SKU = ({ HighchartsReact, Highcharts, data }) => {
  return (
    <>
      <PieChart
        title={"SKU"}
        data={data}
        // data={[
        //   {
        //     name: "250ml",
        //     y: 123,
        //   },
        //   {
        //     name: "500ml",
        //     y: 56,
        //   },
        //   {
        //     name: "1L",
        //     y: 36,
        //   },
        //   {
        //     name: "2L",
        //     y: 0,
        //   },
        // ]}
        Highcharts={Highcharts}
        HighchartsReact={HighchartsReact}
      />
    </>
  );
};

export default SKU;
